// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sample-table-container {
  --table-bg-color: #fff;
  --table-border-color: var(--cui-border-color, #d8dbe0);
  --table-text-color: var(--cui-body-color, #4f5d73);
  --filter-bg-color: #f8f9fa;
  --filter-border-color: #dee2e6;
  --filter-focus-color: var(--cui-primary, #0d6efd);
  width: 100%;
}
html[data-coreui-theme=dark] .sample-table-container {
  --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);
  --table-border-color: var(--cui-dark-border-subtle, #333);
  --table-text-color: var(--cui-body-color, #fff);
  --filter-bg-color: #2a2d3a;
  --filter-border-color: #404552;
  --filter-focus-color: var(--cui-primary, #0d6efd);
}
.sample-table-container .filter-controls .filter-toggle-btn {
  position: relative;
}
.sample-table-container .filter-controls .filter-toggle-btn .filter-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  font-size: 0.7rem;
  font-weight: 600;
  background-color: #dc3545;
  color: white;
  border-radius: 50%;
}
.sample-table-container .filter-controls .clear-filters-btn {
  font-size: 0.875rem;
}
.sample-table-container .filter-panel {
  background-color: var(--filter-bg-color);
  border: 1px solid var(--filter-border-color);
  border-radius: 8px;
  padding: 1rem;
}
.sample-table-container .filter-panel .filter-field .filter-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.5rem;
}
.sample-table-container .filter-panel .filter-field .filter-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.sample-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input-icon {
  position: absolute;
  left: 10px;
  color: #6c757d;
  font-size: 0.875rem;
  z-index: 1;
}
.sample-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input {
  padding-left: 32px;
  padding-right: 32px;
  background-color: var(--table-bg-color);
  border-color: var(--filter-border-color);
  color: var(--table-text-color);
}
.sample-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input:focus {
  border-color: var(--filter-focus-color);
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}
.sample-table-container .filter-panel .filter-field .filter-input-wrapper .filter-clear-btn {
  position: absolute;
  right: 4px;
  padding: 0.25rem;
  color: #6c757d;
}
.sample-table-container .filter-panel .filter-field .filter-input-wrapper .filter-clear-btn:hover {
  color: #dc3545;
}
.sample-table-container .filter-panel .filter-field .decimal-input-group {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}
.sample-table-container .filter-panel .filter-field .decimal-input-group .whole-input {
  flex: 1 1;
  min-width: 0;
}
.sample-table-container .filter-panel .filter-field .decimal-input-group .decimal-separator {
  color: #6c757d;
  font-weight: 600;
  line-height: 1;
}
.sample-table-container .filter-panel .filter-field .decimal-input-group .decimal-input {
  width: 64px;
  flex: 0 0 64px;
  text-align: center;
}
.sample-table-container .filter-panel .filter-field .filter-select {
  background-color: var(--table-bg-color);
  border-color: var(--filter-border-color);
  color: var(--table-text-color);
}
.sample-table-container .filter-panel .filter-field .filter-select:focus {
  border-color: var(--filter-focus-color);
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}
.sample-table-container .card {
  border-color: var(--table-border-color) !important;
  background-color: var(--table-bg-color);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  overflow: hidden;
}
.sample-table-container .card .card-body {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  padding: 1rem;
  width: 100%;
}
.sample-table-container .table-wrapper {
  width: 100%;
  overflow-x: auto;
}
.sample-table-container .sample-table {
  background: var(--table-bg-color);
  margin: 0;
  width: 100%;
  color: var(--table-text-color);
  border-collapse: collapse;
}
.sample-table-container .sample-table .table-header-cell {
  border: 1px solid var(--table-border-color) !important;
  font-weight: 600;
  background-color: var(--filter-bg-color);
  cursor: pointer;
  transition: all 0.2s ease;
}
.sample-table-container .sample-table .table-header-cell:hover {
  background-color: var(--cui-primary, #0d6efd);
  color: white;
}
.sample-table-container .sample-table th, .sample-table-container .sample-table td {
  vertical-align: middle;
  border: 1px solid var(--table-border-color) !important;
  padding: 0.75rem;
}
.sample-table-container .sample-table .image-col {
  width: 80px;
  text-align: center;
}
.sample-table-container .sample-table .actions-col {
  width: 100px;
  text-align: center;
}
.sample-table-container .sample-table .expand-cell {
  width: 40px;
  text-align: center;
}
.sample-table-container .sample-table .row-number-col {
  width: 50px;
  text-align: center;
  font-weight: 500;
}
.sample-table-container .sample-table .id-col {
  width: 60px;
  text-align: center;
}
.sample-table-container .expand-button {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: var(--cui-primary, #0d6efd);
  color: white;
  transition: all 0.2s ease;
}
.sample-table-container .expand-button:hover {
  background-color: var(--cui-primary-darken, #0b5ed7);
  transform: scale(1.1);
}
.sample-table-container .expand-button .expand-icon {
  font-size: 0.75rem;
}
.sample-table-container .expanded-row {
  background-color: rgba(var(--cui-primary-rgb), 0.05) !important;
}
.sample-table-container .detail-row {
  background-color: rgba(var(--cui-primary-rgb), 0.03);
}
.sample-table-container .detail-row .detail-cell {
  padding: 0 !important;
  border-top: none !important;
}
.sample-table-container .detail-content {
  padding: 1rem 2rem;
  border-left: 3px solid var(--cui-primary, #0d6efd);
  margin-left: 20px;
}
.sample-table-container .detail-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}
.sample-table-container .detail-item {
  display: flex;
  flex-direction: column;
  min-width: 150px;
  padding: 0.75rem 1rem;
  background-color: var(--table-bg-color);
  border-radius: 8px;
  border: 1px solid var(--table-border-color);
}
.sample-table-container .detail-item.detail-item-full {
  min-width: 300px;
  flex: 1 1;
}
.sample-table-container .detail-item .detail-label {
  font-size: 0.75rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.sample-table-container .detail-item .detail-value {
  font-size: 1rem;
  font-weight: 600;
  color: var(--table-text-color);
}
.sample-table-container .sample-thumbnail {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.sample-table-container .no-image {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  color: #999;
  font-size: 12px;
}
.sample-table-container .cursor-pointer {
  cursor: pointer;
  transition: transform 0.15s ease;
}
.sample-table-container .cursor-pointer:hover {
  transform: scale(1.2);
}
.sample-table-container .results-info {
  font-size: 0.875rem;
}

[data-coreui-theme=dark] .sample-table-container .sample-thumbnail {
  border-color: rgba(255, 255, 255, 0.1);
}
[data-coreui-theme=dark] .sample-table-container .no-image {
  background: rgba(255, 255, 255, 0.05);
  color: #666;
}

.sample-thumbnail.clickable {
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.sample-thumbnail.clickable:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.image-preview-modal .modal-dialog {
  max-width: 95vw;
}
.image-preview-modal .modal-body {
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000;
  min-height: 400px;
}
.image-preview-modal .preview-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/components/SampleTable/SampleTable.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,sDAAA;EACA,kDAAA;EACA,0BAAA;EACA,8BAAA;EACA,iDAAA;EAEA,WAAA;AAAJ;AAEI;EACI,oDAAA;EACA,yDAAA;EACA,+CAAA;EACA,0BAAA;EACA,8BAAA;EACA,iDAAA;AAAR;AAKQ;EACI,kBAAA;AAHZ;AAKY;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AAHhB;AAOQ;EACI,mBAAA;AALZ;AAUI;EACI,wCAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;AARR;AAWY;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,qBAAA;AAThB;AAYY;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AAVhB;AAYgB;EACI,kBAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;AAVpB;AAagB;EACI,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,wCAAA;EACA,8BAAA;AAXpB;AAaoB;EACI,uCAAA;EACA,iDAAA;AAXxB;AAegB;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;AAbpB;AAeoB;EACI,cAAA;AAbxB;AAkBY;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AAhBhB;AAkBgB;EACI,SAAA;EACA,YAAA;AAhBpB;AAmBgB;EACI,cAAA;EACA,gBAAA;EACA,cAAA;AAjBpB;AAoBgB;EACI,WAAA;EACA,cAAA;EACA,kBAAA;AAlBpB;AAsBY;EACI,uCAAA;EACA,wCAAA;EACA,8BAAA;AApBhB;AAsBgB;EACI,uCAAA;EACA,iDAAA;AApBpB;AA0BI;EACI,kDAAA;EACA,uCAAA;EACA,wCAAA;EACA,WAAA;EACA,gBAAA;AAxBR;AA0BQ;EACI,uCAAA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;AAxBZ;AA4BI;EACI,WAAA;EACA,gBAAA;AA1BR;AA6BI;EACI,iCAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EACA,yBAAA;AA3BR;AA6BQ;EACI,sDAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;EACA,yBAAA;AA3BZ;AA6BY;EACI,6CAAA;EACA,YAAA;AA3BhB;AA+BQ;EACI,sBAAA;EACA,sDAAA;EACA,gBAAA;AA7BZ;AAgCQ;EACI,WAAA;EACA,kBAAA;AA9BZ;AAiCQ;EACI,YAAA;EACA,kBAAA;AA/BZ;AAkCQ;EACI,WAAA;EACA,kBAAA;AAhCZ;AAmCQ;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;AAjCZ;AAoCQ;EACI,WAAA;EACA,kBAAA;AAlCZ;AAuCI;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;EACA,YAAA;EACA,yBAAA;AArCR;AAuCQ;EACI,oDAAA;EACA,qBAAA;AArCZ;AAwCQ;EACI,kBAAA;AAtCZ;AA2CI;EACI,+DAAA;AAzCR;AA6CI;EACI,oDAAA;AA3CR;AA6CQ;EACI,qBAAA;EACA,2BAAA;AA3CZ;AA+CI;EACI,kBAAA;EACA,kDAAA;EACA,iBAAA;AA7CR;AAgDI;EACI,aAAA;EACA,eAAA;EACA,SAAA;AA9CR;AAiDI;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uCAAA;EACA,kBAAA;EACA,2CAAA;AA/CR;AAiDQ;EACI,gBAAA;EACA,SAAA;AA/CZ;AAkDQ;EACI,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AAhDZ;AAmDQ;EACI,eAAA;EACA,gBAAA;EACA,8BAAA;AAjDZ;AAqDI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;AAnDR;AAsDI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AApDR;AAuDI;EACI,eAAA;EACA,gCAAA;AArDR;AAuDQ;EACI,qBAAA;AArDZ;AAyDI;EACI,mBAAA;AAvDR;;AA8DQ;EACI,sCAAA;AA3DZ;AA8DQ;EACI,qCAAA;EACA,WAAA;AA5DZ;;AAkEA;EACI,eAAA;EACA,qDAAA;AA/DJ;AAiEI;EACI,qBAAA;EACA,yCAAA;AA/DR;;AAqEI;EACI,eAAA;AAlER;AAqEI;EACI,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAnER;AAsEI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AApER","sourcesContent":[".sample-table-container {\n    --table-bg-color: #fff;\n    --table-border-color: var(--cui-border-color, #d8dbe0);\n    --table-text-color: var(--cui-body-color, #4f5d73);\n    --filter-bg-color: #f8f9fa;\n    --filter-border-color: #dee2e6;\n    --filter-focus-color: var(--cui-primary, #0d6efd);\n\n    width: 100%;\n\n    html[data-coreui-theme=\"dark\"] & {\n        --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);\n        --table-border-color: var(--cui-dark-border-subtle, #333);\n        --table-text-color: var(--cui-body-color, #fff);\n        --filter-bg-color: #2a2d3a;\n        --filter-border-color: #404552;\n        --filter-focus-color: var(--cui-primary, #0d6efd);\n    }\n\n    // Filter Controls\n    .filter-controls {\n        .filter-toggle-btn {\n            position: relative;\n            \n            .filter-count-badge {\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n                min-width: 18px;\n                height: 18px;\n                padding: 0 5px;\n                font-size: 0.7rem;\n                font-weight: 600;\n                background-color: #dc3545;\n                color: white;\n                border-radius: 50%;\n            }\n        }\n\n        .clear-filters-btn {\n            font-size: 0.875rem;\n        }\n    }\n\n    // Filter Panel\n    .filter-panel {\n        background-color: var(--filter-bg-color);\n        border: 1px solid var(--filter-border-color);\n        border-radius: 8px;\n        padding: 1rem;\n\n        .filter-field {\n            .filter-label {\n                display: block;\n                font-size: 0.75rem;\n                font-weight: 600;\n                color: #6c757d;\n                text-transform: uppercase;\n                letter-spacing: 0.5px;\n                margin-bottom: 0.5rem;\n            }\n\n            .filter-input-wrapper {\n                position: relative;\n                display: flex;\n                align-items: center;\n\n                .filter-input-icon {\n                    position: absolute;\n                    left: 10px;\n                    color: #6c757d;\n                    font-size: 0.875rem;\n                    z-index: 1;\n                }\n\n                .filter-input {\n                    padding-left: 32px;\n                    padding-right: 32px;\n                    background-color: var(--table-bg-color);\n                    border-color: var(--filter-border-color);\n                    color: var(--table-text-color);\n\n                    &:focus {\n                        border-color: var(--filter-focus-color);\n                        box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);\n                    }\n                }\n\n                .filter-clear-btn {\n                    position: absolute;\n                    right: 4px;\n                    padding: 0.25rem;\n                    color: #6c757d;\n                    \n                    &:hover {\n                        color: #dc3545;\n                    }\n                }\n            }\n\n            .decimal-input-group {\n                display: flex;\n                align-items: center;\n                gap: 0.35rem;\n\n                .whole-input {\n                    flex: 1;\n                    min-width: 0;\n                }\n\n                .decimal-separator {\n                    color: #6c757d;\n                    font-weight: 600;\n                    line-height: 1;\n                }\n\n                .decimal-input {\n                    width: 64px;\n                    flex: 0 0 64px;\n                    text-align: center;\n                }\n            }\n\n            .filter-select {\n                background-color: var(--table-bg-color);\n                border-color: var(--filter-border-color);\n                color: var(--table-text-color);\n\n                &:focus {\n                    border-color: var(--filter-focus-color);\n                    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);\n                }\n            }\n        }\n    }\n\n    .card {\n        border-color: var(--table-border-color) !important;\n        background-color: var(--table-bg-color);\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        width: 100%;\n        overflow: hidden;\n\n        .card-body {\n            background-color: var(--table-bg-color);\n            color: var(--table-text-color);\n            padding: 1rem;\n            width: 100%;\n        }\n    }\n\n    .table-wrapper {\n        width: 100%;\n        overflow-x: auto;\n    }\n\n    .sample-table {\n        background: var(--table-bg-color);\n        margin: 0;\n        width: 100%;\n        color: var(--table-text-color);\n        border-collapse: collapse;\n\n        .table-header-cell {\n            border: 1px solid var(--table-border-color) !important;\n            font-weight: 600;\n            background-color: var(--filter-bg-color);\n            cursor: pointer;\n            transition: all 0.2s ease;\n\n            &:hover {\n                background-color: var(--cui-primary, #0d6efd);\n                color: white;\n            }\n        }\n\n        th, td {\n            vertical-align: middle;\n            border: 1px solid var(--table-border-color) !important;\n            padding: 0.75rem;\n        }\n\n        .image-col {\n            width: 80px;\n            text-align: center;\n        }\n\n        .actions-col {\n            width: 100px;\n            text-align: center;\n        }\n\n        .expand-cell {\n            width: 40px;\n            text-align: center;\n        }\n\n        .row-number-col {\n            width: 50px;\n            text-align: center;\n            font-weight: 500;\n        }\n\n        .id-col {\n            width: 60px;\n            text-align: center;\n        }\n    }\n\n    // Expand button\n    .expand-button {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 28px;\n        height: 28px;\n        border-radius: 50%;\n        background-color: var(--cui-primary, #0d6efd);\n        color: white;\n        transition: all 0.2s ease;\n\n        &:hover {\n            background-color: var(--cui-primary-darken, #0b5ed7);\n            transform: scale(1.1);\n        }\n\n        .expand-icon {\n            font-size: 0.75rem;\n        }\n    }\n\n    // Expanded row styling\n    .expanded-row {\n        background-color: rgba(var(--cui-primary-rgb), 0.05) !important;\n    }\n\n    // Detail row (expandable content)\n    .detail-row {\n        background-color: rgba(var(--cui-primary-rgb), 0.03);\n\n        .detail-cell {\n            padding: 0 !important;\n            border-top: none !important;\n        }\n    }\n\n    .detail-content {\n        padding: 1rem 2rem;\n        border-left: 3px solid var(--cui-primary, #0d6efd);\n        margin-left: 20px;\n    }\n\n    .detail-grid {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 2rem;\n    }\n\n    .detail-item {\n        display: flex;\n        flex-direction: column;\n        min-width: 150px;\n        padding: 0.75rem 1rem;\n        background-color: var(--table-bg-color);\n        border-radius: 8px;\n        border: 1px solid var(--table-border-color);\n\n        &.detail-item-full {\n            min-width: 300px;\n            flex: 1;\n        }\n\n        .detail-label {\n            font-size: 0.75rem;\n            color: #6c757d;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n            margin-bottom: 0.25rem;\n        }\n\n        .detail-value {\n            font-size: 1rem;\n            font-weight: 600;\n            color: var(--table-text-color);\n        }\n    }\n\n    .sample-thumbnail {\n        width: 60px;\n        height: 60px;\n        object-fit: cover;\n        border-radius: 4px;\n        border: 1px solid rgba(0, 0, 0, 0.1);\n    }\n\n    .no-image {\n        width: 60px;\n        height: 60px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: rgba(0, 0, 0, 0.05);\n        border-radius: 4px;\n        color: #999;\n        font-size: 12px;\n    }\n\n    .cursor-pointer {\n        cursor: pointer;\n        transition: transform 0.15s ease;\n\n        &:hover {\n            transform: scale(1.2);\n        }\n    }\n\n    .results-info {\n        font-size: 0.875rem;\n    }\n}\n\n// Dark mode support\n[data-coreui-theme=\"dark\"] {\n    .sample-table-container {\n        .sample-thumbnail {\n            border-color: rgba(255, 255, 255, 0.1);\n        }\n\n        .no-image {\n            background: rgba(255, 255, 255, 0.05);\n            color: #666;\n        }\n    }\n}\n\n// Clickable thumbnail\n.sample-thumbnail.clickable {\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n    &:hover {\n        transform: scale(1.1);\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    }\n}\n\n// Image Preview Modal\n.image-preview-modal {\n    .modal-dialog {\n        max-width: 95vw;\n    }\n\n    .modal-body {\n        padding: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #000;\n        min-height: 400px;\n    }\n\n    .preview-image {\n        max-width: 100%;\n        max-height: 90vh;\n        object-fit: contain;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
